<template>
  <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1667 14V12.6667C14.1667 11.9594 13.8857 11.2811 13.3856 10.781C12.8855 10.281 12.2073 10 11.5 10H6.16668C5.45944 10 4.78116 10.281 4.28106 10.781C3.78097 11.2811 3.50002 11.9594 3.50002 12.6667V14M11.5 4.66667C11.5 6.13943 10.3061 7.33333 8.83335 7.33333C7.36059 7.33333 6.16668 6.13943 6.16668 4.66667C6.16668 3.19391 7.36059 2 8.83335 2C10.3061 2 11.5 3.19391 11.5 4.66667Z"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
